module.exports = __webpack_public_path__ + "img/car.fdfa1e9c.svg";